import { React, useContext } from 'react';
import AdminDashboard from './AdminDashboard'
import ManagerDashboard from './ManagerDashboard'
import CustomerPage from '../customers/CustomerDetail'
import { AppContext } from '../../services/AppContext';

const Home = () => {
    const { user } = useContext(AppContext);

    return (
      <div>
        {user.role === 'Admin' ? (<AdminDashboard />) : <div></div> }
        {user.role === 'Manager' ? (<ManagerDashboard />) : <div></div> }
        {user.role === 'Customer' ? (<CustomerPage />) : <div></div> }
      </div>
    );
  };

  export default Home;